
  import {Component, Vue} from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import {formatDateForServer} from "@/plugins/moment";
  import {bus} from "@/plugins/bus";
  import {IDialog} from "@/modules/Popup/interfaces/dialog.interface";
  import {KeyboardMobileHidden} from "@/plugins/keyboard-mobile-hidden";
  import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";
  import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
  import AppDatePicker from "@/components/FormControls/AppDatePicker.vue";
  import CarCardMoveTable from "@/modules/Report/Movements/components/specialComponents/CarCardMoveTable.vue";
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import {ICarPopupTables} from "@/modules/Car/interfaces/car-popup-tables.interface";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {
      CarCardMoveTable,
      AppDatePicker,
    }
  })
  export default class CarTableMovements extends Vue {
    $refs: any;
    format = IApp.DATE_FORMAT_ELEMENT_UI;
    dateFormats = IApp.DateFormats;
    loadingData = false;
    defaultValues = {
      dateBeg: '',
      dateEnd: '',
      payFlag: false,
    };
    formModel = {
      dateBeg: '',
      dateEnd: '',
      payFlag: false,
    };

    get storeState(): IAppState { return this.$store.state; }
    get activeCar(): ICar.IEntity { return this.storeState.car.activeCar; }
    get carNumber() { return this.activeCar ? this.activeCar.carNumber : this.storeState.car.popupPayload.carNumber; }
    get dateEmpty() { return !Boolean(this.formModel.dateBeg) && !Boolean(this.formModel.dateEnd); }
    get tableList(): IMovementsReport.ICarPopupTableItem[] {
      let tables = this.storeState.car.tables;
      return !tables || (tables && !tables[ICarPopupTables.CarPopupTables.movements])
        ? []
        : tables[ICarPopupTables.CarPopupTables.movements];
    }

    async mounted() {
      bus.$on(IDialog.Events.CAR_POPUP_UPDATE_MOVEMENTS, () => {
        this.$store.commit('car/setProperty', { name: 'displayContent', value: true });
        this.getData();
      });

      bus.$on(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.CarPopupMovements,
        async ({ indexRow, direction }) => {
        let index = indexRow;
        if (direction === +1) index = indexRow === this.tableList.length - 2 ? 0 : indexRow + direction;
        else index = indexRow === 0 ? this.tableList.length - 2 : indexRow + direction;
        await this.openMediaPopup(index);
      });
    }

    async prepareData() {
      if (!this.tableList.length) await this.getData();

      KeyboardMobileHidden();
    }

    async getData() {
      this.loadingData = true;

      let params: ICarPopupTables.ICarTableParams = {
        command: ICarPopupTables.Command.GetMovements,
        carNumber: this.carNumber,
        payFlag: this.formModel.payFlag,
      };
      if (this.formModel.dateBeg) params.fltDateBeg = formatDateForServer(this.formModel.dateBeg, IApp.DateFormats.PrintedDate);
      if (this.formModel.dateEnd) params.fltDateEnd = formatDateForServer(this.formModel.dateEnd, IApp.DateFormats.PrintedDate);

      await this.$store.dispatch('car/getTable', params);
      this.loadingData = false;
    }

    async addMovement() {
      this.$store.commit('car/setProperty', { name: 'displayContent', value: false });
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'reports',
        dialogName: 'reportMovementsChange',
        payload: {
          fromCarPopup: true,
          carNumber: this.carNumber,
          corpId: this.activeCar ? this.activeCar.corpId : null,
          carId: this.activeCar ? this.activeCar.carId : null,
        }
      });
    }

    async openMediaPopup(index: number) {
      const actionComponent = this.$refs.CarCardMoveTable.$refs.SimpleAppTable.$refs.ActionsCell[index];
      if (actionComponent) {
        await actionComponent.openMediaPopup();
      }
    }

    pickerShortcutAction(dates: { start?: string; end?: string; }) {
      if (dates.start) this.formModel.dateBeg = dates.start;
      if (dates.end) this.formModel.dateEnd = dates.end;
    }

    destroyed() {
      bus.$off(IDialog.Events.CAR_POPUP_UPDATE_MOVEMENTS);
      bus.$off(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.CarPopupMovements);
    }
  }
